import { AbstractShape } from "../abstract/Shape";
import { Connection } from "./Connection";

export class ConnectionRef {
    connection: Connection | null | undefined = null;
    setConnection(connection: Connection | null | undefined = null){
        this.connection = connection;
    }

    getConnection(){
        return this.connection;
    }
}